// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> domain-at-founders-parc-8fcb
// Generated: 2026-11-03T20:36:54.049Z
// Counts: 2 design, 82 content, 37 slot group, 4 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Domain at Founders Parc, we're committed to creating a welcoming online experience for every visitor. We continually work to make our website accessible and easy to navigate for people of all abilities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From a resort-inspired pool with cabanas and a water feature to a fitness studio with yoga and spin, Domain at Founders Parc surrounds you with spaces made for relaxing, working, and playing. Warm up by the in-ground fire pit, grill in the outdoor kitchen, catch up in the cyber lounge and coffee bar, and let your pup roam the dog park—then step inside to homes finished with modern style.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Your renovated one-, two-, or three-bedroom home in the heart of Euless is just an application away—complete with stainless-steel appliances, wood-style flooring, and resort-style amenities right outside your door. Apply online in minutes and make your move to Domain at Founders Parc.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>We'd love to hear from you.</strong> Reach out to the Domain at Founders Parc leasing team for a tour, floor plan details, or directions to our community in the heart of Euless. Whether you're a prospective resident exploring modern one-, two-, and three-bedroom apartments or a current resident who needs a hand, we're here to help every step of the way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>From championship golf and lakeside parks to Grapevine's family attractions and Euless's favorite local eats, there's always something to explore around Domain at Founders Parc. Browse a few of our neighborhood picks below and start finding your own go-to spots.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Find the layout that fits your life at Domain at Founders Parc.</strong> Compare one-, two-, and three-bedroom apartment homes in Euless—from an efficient 673-square-foot one-bedroom to a spacious 1,458-square-foot three-bedroom—each finished with stainless-steel appliances, wood-style flooring, and in-home laundry. Browse the cards below for current pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Take a closer look at life at Domain at Founders Parc.</strong> These photos walk you through renovated one-, two-, and three-bedroom homes with stainless-steel appliances, wood-style flooring, kitchen islands, and spa-inspired baths, alongside resort-style spaces like the cabana-lined pool, fitness studio, cyber café, and outdoor kitchen. Scroll through to picture your Euless apartment from every angle—then compare available floor plans or explore virtual tours when a scene stands out.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Domain at Founders Parc puts the best of the Mid-Cities within easy reach, from tee times at the 275-acre Texas Star Golf Course to shops and dining along Grapevine's historic Main Street. Spend weekends at SEA LIFE Grapevine Aquarium and LEGOLAND, catch a film at Cinépolis Luxury Cinemas, and hop TEXRail near DFW Airport for a quick trip into Fort Worth or Dallas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Bring the pets, keep the routine easy.</strong> At Domain at Founders Parc, cats and dogs settle in with pet-friendly touches that go beyond the policy—an on-site bark park for burning off energy and a dog wash for those messy outdoor moments. Wood-style flooring, in-home washer and dryer, and generous walk-in closets make room for leashes, towels, and everything else that comes with a well-loved companion.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Domain at Founders Parc, protecting your personal information is part of the polished, resident-first experience we're known for. Here's how we collect, use, and safeguard the details you share with us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f237d-ab13-7458-959f-0eccf3370c8c.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Your resident portal, available 24/7.</strong> Log in to pay rent online, submit and track maintenance requests, and stay in the loop on community updates—so more of your time at Domain at Founders Parc is spent enjoying the pool, fitness studio, and cyber lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents describe Domain at Founders Parc as a quiet, spotless, and modern community where the leasing and maintenance teams go above and beyond to make everyone feel like family. Read on to hear firsthand why they recommend calling it home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Experience Domain at Founders Parc for yourself.</strong> Book an in-person or virtual tour to walk renovated one-, two-, and three-bedroom homes with stainless-steel appliances, wood-style flooring, and in-home laundry, then take in the resort-inspired pool, fitness studio, and cyber lounge. Schedule your visit today and picture your next move in the heart of Euless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse floor plans, amenities, and neighborhood highlights to discover everything life at Domain at Founders Parc has to offer.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you—your inquiry has been received.</strong> Our leasing team will be in touch soon, and we can't wait to show you renovated one-, two-, and three-bedroom living and resort-style spaces at Domain at Founders Parc in the heart of Euless.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Take a virtual walk through Domain at Founders Parc before you ever set foot in Euless.</strong> Move through the pool deck, fitness studio, cyber lounge, and other resort-style shared spaces at your own pace to get a real feel for the finishes and everyday flow. When you're ready to see it in person, browse the <a href=\"/gallery\">photo gallery</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Contact us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex courtyard with swimming pool and lounge chairs."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-2ee9-7003-9091-63e5236c5cf8.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Spin bikes and exercise equipment in the property's fitness center."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-282f-765c-9ade-463d570b2930.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Fitness & Spin Studio"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern coworking space with private workstations and comfortable seating."
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-07c5-7170-9b49-d85c476c7be5.webp"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Cyber Lounge & Coffee Bar"
      }
    }
  },
  "amenitieshomesection.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "American Landmark 360"
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-208a-722d-9889-5e304df65dd0.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Resident lounge with leather chairs and modern decor"
      }
    }
  },
  "amenitieshomesection.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Cabinets"
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-3fbd-716d-a099-3b6d4abf2036.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Contemporary dark wood cabinetry in a modern kitchen"
      }
    }
  },
  "amenitieshomesection.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "false"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Counters"
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-31f0-735c-908d-f1e8537339af.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Sleek quartz countertops and large island in a modern kitchen"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with in-water loungers and lounge chairs surrounding the pool."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-484e-7645-b8c3-64ce9943f3f8.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>Our resort-inspired pool is the heart of the community—complete with cabanas, a water feature, and plenty of lounge seating for soaking up the Texas sun. Whether you're cooling off after a workout or unwinding on the weekend, it's a destination that makes home feel like a getaway just steps from your door.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-3cbd-70cb-8cd8-18f03755527a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, a large island with bar stools, and a dining area."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-97b2-722e-8c03-a1a399f4ebe9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Texas Star Golf Course"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Texas Star Golf Course"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://www.texasstargolf.com/"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8c70-7066-9f71-dbfa1ceb6a53.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "SEA LIFE Grapevine Aquarium"
      },
      "title": {
        "type": "VALUE",
        "customValue": "SEA LIFE Grapevine Aquarium"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.visitsealife.com/grapevine/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019f150d-8056-7790-8da0-8b925f9760b1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cinépolis Luxury Cinemas Euless"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Cinépolis Luxury Cinemas Euless"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.cinepolisusa.com/euless/theater-details"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-4c9f-714a-b2e6-f66e28a23e43.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and cabanas."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and cabanas"
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-4c8d-75ed-a6bb-5763b589c538.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior view of a modern apartment gym with cardio machines, weight training equipment, and medicine balls."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Modern fitness center with cardio machines and weight training equipment"
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-3cbd-70cb-8cd8-18f03755527a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, a large island with bar stools, and a dining area."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Gourmet kitchen with stainless steel appliances and a large island with bar stools"
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-5091-72b9-8fed-f3c0f6946786.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom with a king-size bed, two framed abstract art pieces, a ceiling fan, and a large window with blinds."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Spacious bedroom with a king-size bed and large window with natural light"
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-57ac-7548-848d-869ed1526444.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a modern apartment building with balconies and landscaping."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Exterior view of the modern apartment building with balconies and landscaping"
      }
    }
  },
  "interiorintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-43cc-75f8-b094-a5ebe06e2269.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Renovated open-concept living room and kitchen with modern dark cabinetry, a large island, and wood-style flooring at Domain at Founders Parc."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-246a-759b-8790-d9b28d7e3ec0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, surrounded by trees and a pond."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Aerial view of the apartment community surrounded by trees and a pond in Euless"
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d4cf5-5be6-775c-8ea7-059e934e0193.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex with multiple buildings, a parking lot, and surrounding greenery."
      },
      "alt_text": {
        "type": "VALUE",
        "customValue": "Aerial view of the community with multiple buildings and surrounding greenery"
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-4c9f-714a-b2e6-f66e28a23e43.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and cabanas."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-5131-734b-86ef-73880e90faaa.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fully equipped fitness center with weight machines, free weights, and cardio equipment."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5684048244506624/019d02f0-3fbd-716d-a099-3b6d4abf2036.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with pendant lighting."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-4bf6-71d4-8344-22e2b99c2a21.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building exterior with balconies and landscaping."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://domainatfoundersparc.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-541d-7669-8d91-6516611e2547.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and open-concept kitchen with island seating."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://domainatfoundersparc.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5684048244506624/019e8991-484e-7645-b8c3-64ce9943f3f8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with in-water loungers and lounge chairs surrounding the pool."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "neighborhoodhomesection.neighborhood_pois": {
    "limit": null,
    "hiddenIds": [
      "custom_5ed57cd3-8c4b-404a-b0fd-daab15cf075f"
    ],
    "orderedIds": [
      "custom_d518b769-cad4-4174-bc28-4a088f3c7482",
      "custom_644068c5-d666-4cd1-988a-fd2fc940be52",
      "custom_d39cb0a9-15a1-484c-a1b3-9b6313113fbf",
      "custom_d0f5fb47-dd1f-43ef-ac8b-8e1a0c94f40e",
      "custom_d3531ca5-45ad-4d8e-ae65-57c6860ea9cd",
      "custom_c1c6c16a-d485-41c5-9018-7856c2aaee0a",
      "custom_36d1b6ba-8d02-47e0-982c-f80b0cbe7b8a",
      "custom_9f5a7607-510d-4238-8f4a-26aa31d1c1ea",
      "custom_6b2ab1a4-b764-4bfe-883c-c41831c5a1ac",
      "custom_1afce38f-f910-4d13-818f-1c15bf94f161",
      "custom_bb7acffa-f69d-43d0-88c2-37aad7f6c691",
      "custom_719e057a-2019-47a5-8591-25860ea3dc32",
      "custom_0bf4c9d3-b2bc-46dd-8a2a-1c64b4ac0590",
      "custom_8cf61372-925d-4aa5-8ebf-0ba7a68f03c5",
      "custom_647c5bb5-48ad-4bf5-a0da-960d80fb6487",
      "custom_c45ef4e8-d47c-4d86-8609-e2ef5ab67ddb",
      "custom_5ed57cd3-8c4b-404a-b0fd-daab15cf075f",
      "custom_d64b70e5-7ae7-4cb5-8468-049d22be411a",
      "custom_681dd397-9a5e-419e-b671-08cf14591d33",
      "custom_aa3102da-3276-4ebb-9f0c-e21f4258ac88",
      "custom_29128b93-7b4d-4afe-a5bf-f032dae2a14e",
      "custom_007f829d-abec-404a-bd4f-c20afb87bd2d",
      "custom_6ea7934d-cf60-4725-b2bd-f67b60a9206a",
      "custom_f8c34804-f1fb-4ff6-87c9-33e3aced033e",
      "custom_5caca7cd-96b2-4a4b-86ba-714e3430e153",
      "custom_5f186343-7ca3-45ec-a060-1051e7bb9f9c",
      "custom_f756f488-f2e7-4d8d-be6a-07c22c4ef722",
      "custom_f1569768-762b-46de-b783-dde087eae85d",
      "custom_1cdfd7cb-a9d4-4ad5-b286-f970100e3169",
      "custom_8bb245e1-9d68-45c4-9771-1870af521d0d",
      "custom_edaa99b0-bfb2-44e5-b647-ea12fe44ab65",
      "custom_2e2acc4a-1878-487d-aaa0-a5cec12b9fe0",
      "custom_72ecb353-0f4a-48d4-976a-ac8ce3a36efb",
      "custom_9918d25c-cc4b-4965-b766-321079b28ba3",
      "custom_f0f09f75-d0e4-487c-a35c-af1351674465",
      "custom_f9f7710a-b230-4b4e-86f5-6564739bb033",
      "custom_4de2a275-ccaf-4cfd-8f5d-cac6eb270d5c",
      "custom_be756b81-6b29-4be9-8f0a-910f30bc7d8c",
      "custom_45f718a8-40d6-4950-8d6a-9420b7267f53",
      "custom_ca5baee4-d373-4182-94f9-6ccaae9b7be3",
      "custom_310a098d-0c59-44c0-b5f7-1d5e25817fd7",
      "custom_055f31fd-7b72-4916-b595-7446f26eac2c",
      "custom_dc2450dd-eee6-433e-8330-d3b7683a0de8",
      "custom_fd5f5ffe-915d-47b8-8a50-d00b7bf4e422",
      "custom_82593e02-f49e-42d5-a76d-46795c831dad",
      "custom_41278ca3-65e6-47e6-8a5c-4f9a6978f86e",
      "custom_08ec72d5-99dd-4c83-bd70-0ed269e5614c",
      "custom_a2d46f00-1809-4042-bb04-3c5eac819743",
      "custom_9a1b3f12-aac6-49df-807f-21941aba6318",
      "custom_75e818ec-3386-4534-ab77-8cd2ea4fd476",
      "custom_b4001795-8b58-4b1c-93ef-2e2454670d07",
      "custom_1e2ca1fd-294e-40f7-a4f2-a52e9d63db8f",
      "custom_69d23922-1b98-4aa1-8d3f-4cb5d6ad73fd",
      "custom_4f0e022b-2a76-48b0-a77c-ffdae35837fa",
      "custom_8b7f404a-bf74-43a9-ad0a-f7acd92ab10d",
      "custom_3c12377e-2c79-4d1a-95ea-23800365d33b",
      "custom_b2712f8e-606e-4f31-ad35-e0afee8a4c0e",
      "custom_9dc94194-bb13-4952-9585-095200202535",
      "custom_da16f2b3-9147-4866-bd9c-d8371dd2f493",
      "custom_c9ead93d-6d1e-4a5a-88c0-0396a6241255",
      "custom_a1616cd5-ab75-4b46-bcda-3b88a8bee79d",
      "custom_d17fc05a-2463-4aae-970b-31e7bbffc87a",
      "custom_55bf41fd-4f02-4655-9fe8-49c49c289b1f",
      "custom_82438bd9-81b4-47c2-b049-fa41763b0aaf",
      "custom_f2133594-969e-4485-867b-008abc82cf1b",
      "custom_714e1129-9227-4795-9f72-686c6bf885bc",
      "custom_8ecab995-310e-4d63-9ece-85c24115beaa",
      "custom_e6b3944a-5dc7-4c24-b573-2549fdfd012a",
      "custom_7f0bea7f-d5f5-4937-9bd5-dca5e17362b6",
      "custom_1519e27a-0c54-49dd-9e0f-e5428f8c5631",
      "custom_88bddf03-68a4-4dfb-9b49-6ce45ba3a017",
      "custom_71a9641f-b48a-437b-bda7-50b42fc6873c",
      "custom_af5857fa-c232-475f-80c1-18a983db2cea",
      "custom_d733b002-d53a-44e0-8966-b29f656096c2",
      "custom_ba6fd73f-d72c-4996-b61d-4a1a2692cc64",
      "custom_e7324fb5-cd62-41d7-8015-bb6819b57f16",
      "custom_61ee9953-2c9b-4b39-8f0e-cfd3e0991f40",
      "custom_e88400eb-ac33-47aa-8868-dd3747745fd4",
      "custom_f233de2b-4b0e-4324-9290-1f2e25641d4e",
      "custom_b43b14ca-b9c1-489e-9ef7-8c95a895ac09",
      "custom_b067fd03-9ac2-49a8-9df6-7eeb6908ec1d",
      "custom_78f83b50-d68a-4ce9-bb2d-3e56e4840e98"
    ],
    "hiddenIndices": [
      16
    ],
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      81,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77,
      78,
      79,
      80
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
